<app-youtube-player-lazy [videoId]="videoId"></app-youtube-player-lazy>
<app-json-ld [json]="seoYoutubeVideo"></app-json-ld>
